import { render, staticRenderFns } from "./zhengzhouTemp.vue?vue&type=template&id=56dbf36f&scoped=true"
import script from "./zhengzhouTemp.vue?vue&type=script&lang=js"
export * from "./zhengzhouTemp.vue?vue&type=script&lang=js"
import style0 from "./zhengzhouTemp.vue?vue&type=style&index=0&id=56dbf36f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dbf36f",
  null
  
)

export default component.exports